// src/utils/timezoneHeader.ts
// Every axios call to our API carries the browser's IANA timezone as
// X-Timezone, so the server counts streak days in the learner's local
// calendar wherever the activity ends. Other hosts (S3, TTS) are untouched.
import axios from "axios";
import { browserTimezone } from "../Components/Streak/streakModel";

let installed = false;

export function installTimezoneHeader(apiBase = process.env.REACT_APP_API_BASE_URL || ""): void {
  if (installed || !apiBase) return;
  installed = true;
  const tz = browserTimezone();
  if (!tz) return;
  axios.interceptors.request.use((config) => {
    const url = config.url || "";
    if (url.startsWith(apiBase) || url.startsWith("/api/")) {
      config.headers = config.headers || {};
      (config.headers as any)["X-Timezone"] = tz;
    }
    return config;
  });
}
